@if (type() === ErrorImageType.TYPE_1) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="214"
    height="150"
    fill="none"
    viewBox="0 0 214 150"
  >
    <g clip-path="url(#a)">
      <path
        fill="#fff"
        d="M134.439 50.92c-11.318 0-22.84-.46-33.617-3.462-10.575-2.934-20.284-8.627-28.939-15.213-5.666-4.286-10.818-7.708-18.174-7.194a33.685 33.685 0 0 0-19.635 7.668c-9.358 8.194-7.951 23.38-4.206 34.009 5.626 16.051 22.746 27.235 37.296 34.469 16.809 8.398 35.28 13.279 53.793 16.079 16.227 2.474 37.079 4.259 51.143-6.329 12.914-9.75 16.457-31.981 13.292-46.991a18.453 18.453 0 0 0-6.639-11.251c-9.074-6.64-22.61-2.204-32.806-1.988-3.786.081-7.64.176-11.508.203Zm-27.153 92.671c27.416 0 49.641-1.387 49.641-3.097s-22.225-3.097-49.641-3.097c-27.417 0-49.642 1.387-49.642 3.097s22.225 3.097 49.642 3.097Z"
      />
      <path
        fill="#F2F3F6"
        d="M134.439 50.92c-11.318 0-22.84-.46-33.617-3.462-10.575-2.934-20.284-8.627-28.939-15.213-5.666-4.286-10.818-7.708-18.174-7.194a33.685 33.685 0 0 0-19.635 7.668c-9.358 8.194-7.951 23.38-4.206 34.009 5.626 16.051 22.746 27.235 37.296 34.469 16.809 8.398 35.28 13.279 53.793 16.079 16.227 2.474 37.079 4.259 51.143-6.329 12.914-9.75 16.457-31.981 13.292-46.991a18.453 18.453 0 0 0-6.639-11.251c-9.074-6.64-22.61-2.204-32.806-1.988-3.786.081-7.64.176-11.508.203Zm-27.153 89.671c27.417 0 49.642-1.387 49.642-3.097s-22.225-3.097-49.642-3.097c-27.416 0-49.642 1.387-49.642 3.097s22.226 3.097 49.642 3.097Z"
      />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M65.797 112.678c-12.742 0-23.072-10.095-23.072-22.548 0-12.453 10.33-22.547 23.072-22.547.542 0 1.08.018 1.612.054a35.87 35.87 0 0 1-.563-6.347c0-19.692 15.964-35.656 35.656-35.656 15.722 0 29.067 10.175 33.81 24.298a32.872 32.872 0 0 1 3.42-.178c17.665 0 31.986 14.086 31.986 31.462 0 16.508-12.925 30.127-29.364 31.439v.023H65.797Zm12.58 0h-7.303 7.304Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-width="1.8"
        d="M78.378 112.678h-7.304m-5.277 0c-12.742 0-23.072-10.095-23.072-22.548 0-12.453 10.33-22.547 23.072-22.547.542 0 1.08.018 1.612.054a35.87 35.87 0 0 1-.563-6.347c0-19.692 15.964-35.656 35.656-35.656 15.722 0 29.067 10.175 33.81 24.298a32.872 32.872 0 0 1 3.42-.178c17.665 0 31.986 14.086 31.986 31.462 0 16.508-12.925 30.127-29.364 31.439v.023H65.797Z"
      />
      <path
        fill="#F2F3F6"
        fill-rule="evenodd"
        d="M91.609 33.334c0 33.793 30.434 61.639 69.622 65.398-4.911 6.039-12.495 10.136-21.135 10.779v.02H69.723c-8.539 0-22.803-3.597-22.803-19.35 0-15.754 11.09-19.351 22.803-19.351.498 0 .992.016 1.481.046-.34-1.767-.4-3.589-.517-5.446-.796-12.546 4.678-28.358 20.94-33.504-.012.469-.018.938-.018 1.408Zm11.015 52.871c-3.186 0-5.77 2.553-5.77 5.702 0 3.15 2.584 5.702 5.77 5.702 3.187 0 5.771-2.553 5.771-5.702s-2.584-5.702-5.771-5.702Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#B4B7BD"
        stroke-width="1.8"
        d="M103.027 97.996a5.768 5.768 0 1 0-.001-11.535 5.768 5.768 0 0 0 .001 11.535Z"
      />
      <path
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="m86.771 80.167 7.341-5.761-7.34-5.484m32.51 11.245-7.341-5.761 7.341-5.484"
      />
      <path
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-width="1.8"
        d="M112.99 36.121a19.963 19.963 0 0 1 14.095 13.94"
      />
      <path
        stroke="#C9CBCF"
        stroke-width="1.8"
        d="M135.013 18.292a3.146 3.146 0 1 0 0-6.292 3.146 3.146 0 0 0 0 6.292Z"
      />
      <path
        fill="#C9CBCF"
        stroke="#C9CBCF"
        stroke-width="1.8"
        d="M169.769 31.927a2.246 2.246 0 1 1-4.493 0 2.246 2.246 0 0 1 4.493 0Z"
      />
      <path
        fill="#C9CBCF"
        fill-rule="evenodd"
        d="m152.047 26.428-8.766 8.765 8.766-8.765Zm-8.899 0 8.766 8.765-8.766-8.765Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#C9CBCF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="m143.148 26.428 8.766 8.765m.133-8.765-8.766 8.765 8.766-8.765Z"
      />
      <path
        fill="#C9CBCF"
        fill-rule="evenodd"
        d="m50.49 45.136-6.292 6.292 6.292-6.292Zm-6.292 0 6.292 6.292-6.292-6.292Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#C9CBCF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="m44.198 45.136 6.292 6.292m0-6.292-6.292 6.292 6.292-6.292Z"
      />
      <path
        fill="#C9CBCF"
        stroke="#C9CBCF"
        stroke-width="1.8"
        d="M60.702 35.072a2.246 2.246 0 1 1-4.492 0 2.246 2.246 0 0 1 4.492 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h214v150H0z"
        />
      </clipPath>
    </defs>
  </svg>
}
@if (type() === ErrorImageType.TYPE_2) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="214"
    height="150"
    fill="none"
    viewBox="0 0 214 150"
  >
    <g clip-path="url(#a)">
      <path
        fill="#fff"
        d="M134.439 50.92c-11.318 0-22.84-.46-33.617-3.462-10.575-2.934-20.284-8.627-28.939-15.213-5.666-4.286-10.818-7.708-18.174-7.194a33.685 33.685 0 0 0-19.635 7.668c-9.358 8.194-7.951 23.38-4.206 34.009 5.626 16.051 22.746 27.235 37.296 34.469 16.809 8.398 35.28 13.279 53.793 16.079 16.227 2.474 37.079 4.259 51.143-6.329 12.914-9.75 16.457-31.981 13.292-46.991a18.453 18.453 0 0 0-6.639-11.251c-9.074-6.64-22.61-2.204-32.806-1.988-3.786.081-7.64.176-11.508.203Zm-27.153 92.671c27.416 0 49.641-1.387 49.641-3.097s-22.225-3.097-49.641-3.097c-27.417 0-49.642 1.387-49.642 3.097s22.225 3.097 49.642 3.097Z"
      />
      <path
        fill="#F2F3F6"
        d="M134.439 50.92c-11.318 0-22.84-.46-33.617-3.462-10.575-2.934-20.284-8.627-28.939-15.213-5.666-4.286-10.818-7.708-18.174-7.194a33.685 33.685 0 0 0-19.635 7.668c-9.358 8.194-7.951 23.38-4.206 34.009 5.626 16.051 22.746 27.235 37.296 34.469 16.809 8.398 35.28 13.279 53.793 16.079 16.227 2.474 37.079 4.259 51.143-6.329 12.914-9.75 16.457-31.981 13.292-46.991a18.453 18.453 0 0 0-6.639-11.251c-9.074-6.64-22.61-2.204-32.806-1.988-3.786.081-7.64.176-11.508.203Zm-27.153 89.671c27.417 0 49.642-1.387 49.642-3.097s-22.225-3.097-49.642-3.097c-27.416 0-49.642 1.387-49.642 3.097s22.226 3.097 49.642 3.097Z"
      />
      <path
        fill="#C9CBCF"
        d="M87.446 54.218h-5.341v36.928h5.341V54.218Z"
      />
      <path
        fill="#C9CBCF"
        d="m81.999 56.908 2.544 4.696 30.879-16.73-2.545-4.697-30.878 16.73Z"
      />
      <path
        fill="#fff"
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M80.394 87.95h8.174a15.716 15.716 0 0 1 15.716 15.716v1.149H64.678v-1.149A15.716 15.716 0 0 1 80.394 87.95Z"
      />
      <path
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M109.681 104.998h-50.4"
      />
      <path
        fill="#fff"
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M85.105 67.817a9.267 9.267 0 1 0 0-18.534 9.267 9.267 0 0 0 0 18.534Zm51.78 26.953c-.238-.085-2.033.083-2.257 0-1.612-.603-2.187 1.401-3.673.574a43.587 43.587 0 0 1 29.974-81.174c1.769.427.682 1.325 2.386 1.962.323.112 2.367 1.486 2.675 1.599l-29.105 77.038Z"
      />
      <path
        fill="#DFE1E5"
        stroke="#B4B7BD"
        stroke-width="1.8"
        d="M163.231 60.895c-6.621 17.79-16.401 31.321-24.327 34.793a9.22 9.22 0 0 1-3.379.868 6.357 6.357 0 0 1-2.61-.371 5.97 5.97 0 0 1-1.799-1.062 5.722 5.722 0 0 1-.825-.813c-5.494-6.297-4.601-24.803 2.748-44.645 7.28-19.54 18.433-33.994 26.689-35.483a6.76 6.76 0 0 1 1.552-.137c.699.015 1.39.145 2.047.386a6.514 6.514 0 0 1 2.459 1.667 10.62 10.62 0 0 1 1.813 2.646c3.695 7.84 2.225 24.486-4.368 42.151Z"
      />
      <path
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="m134.552 48.386 43.798 15.996"
      />
      <path
        fill="#fff"
        stroke="#B4B7BD"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M175.826 69.22a6.113 6.113 0 1 0 0-12.227 6.113 6.113 0 0 0 0 12.226ZM70 30.462a6.4 6.4 0 0 1-.512 2.506 6.53 6.53 0 0 1-1.457 2.123 6.717 6.717 0 0 1-2.18 1.416 6.85 6.85 0 0 1-2.57.493H46.81c-1.276 0-2.5-.494-3.402-1.374A4.634 4.634 0 0 1 42 32.308c0-1.245.507-2.438 1.41-3.318a4.873 4.873 0 0 1 3.401-1.374c.631 0 1.257.117 1.844.344a4.399 4.399 0 0 1-.096-.923 5.013 5.013 0 0 1 1.298-3.31 5.252 5.252 0 0 1 3.2-1.68 5.318 5.318 0 0 1 3.548.77 5.096 5.096 0 0 1 2.17 2.844 6.618 6.618 0 0 1 4.506-1.72 6.852 6.852 0 0 1 2.566.49 6.719 6.719 0 0 1 2.178 1.413 6.53 6.53 0 0 1 1.459 2.118c.338.792.514 1.642.516 2.5Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h214v150H0z"
        />
      </clipPath>
    </defs>
  </svg>
}
